import isEmpty from 'lodash/fp/isEmpty';
import { DEFAULT_ROUTE } from '../../common/constants';
import type { RootDispatch, RootState } from '../../configuration/setup/store';
import { updateDraftExistsFlag, updatePage } from '../../store/app/appSlice';
import {
    selectCurrentTour,
    selectTourHandlingItineraries,
    selectTourHandlingSelectedItinerary,
} from '../../store/tour/tourSelectors';
import { seedItinerariesFromHandling, updateTourId, updateTourItineraryId } from '../../store/tour/tourSlice';
import { prefillTourSettings, reapplyVehicleProfileTourFields } from './prefillTourSettings';

const selectSeededItineraryId = (state: RootState): string | undefined => {
    const itineraries = selectTourHandlingItineraries(state);
    const selectedItinerary = selectTourHandlingSelectedItinerary(state);
    return itineraries?.[selectedItinerary ?? 0]?.itineraryId;
};

export const editTour = (dispatch: RootDispatch, getState: () => RootState): void => {
    const state = getState();
    const currentTour = selectCurrentTour(state);
    const itineraries = selectTourHandlingItineraries(state);

    if (!currentTour?.tourId || isEmpty(itineraries)) {
        return;
    }

    // Seed the planning-flow itineraries from the handling data so that
    // RouteSummaryPage and FinishButton work immediately, and so that
    // updateItineraryWaypoints (inside prefillTourSettings) can resolve
    // selectItinerary from the planning flow rather than the fallback.
    dispatch(seedItinerariesFromHandling());

    dispatch(prefillTourSettings);
    dispatch(updateTourId(currentTour.tourId));
    dispatch(updateTourItineraryId(selectSeededItineraryId(state)));
    dispatch(updateDraftExistsFlag(false));
    dispatch(updatePage(DEFAULT_ROUTE));

    // Fire-and-forget — editTour itself stays synchronous (Requirement 5.2)
    void reapplyVehicleProfileTourFields(dispatch, getState, currentTour);
};
